import React, { useState } from 'react';
import { Button, Card, Dropdown, Icon, Input } from 'semantic-ui-react';
import ScfoButton from 'src/components/shared/ScfoButton';
import { useDispatch } from 'react-redux';
import { importAlertState } from 'src/redux/actions/alert';
import { importUpdateCashflowNeeded } from 'src/redux/actions/flujocaja';
import { updateConcilieantionRatio } from 'src/redux/actions/dashboard';
import { setUpdateDocuments } from 'src/redux/actions/documentostributarios';
import { CreateCheckDocument } from 'src/graphql/documents';
import moment from 'moment';
import { CurrencyIcon } from 'src/utils/currencyIcon';
import CustomModal from '../../configuracion/components/customModal';
import { useBlockedFeatures } from 'src/hooks/useBlockedFeatures';

export const ChequePayoff = ({ companyId, option, selected }) => {
    const [selectedDocument] = selected
    const dispatch = useDispatch();
    const { isAbonarBlocked } = useBlockedFeatures();
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [counter, setCounter] = useState(0);
    const [document, setDocument] = useState([
        {
          amount: parseFloat(selectedDocument.meta?.remaining),
          documentId: null,
          dueDate: null,
          key: counter + 1,
        },
      ]);
    const handleOpen = () => {
        if (isAbonarBlocked()) {
            dispatch(importAlertState({
                content: 'La función "Abonar" está bloqueada para tu cuenta.',
                state: 'warning',
                duration: 4,
            }));
            return;
        }
        setOpen(true);
    };
    const handleClose = () => {
      setDocument([
        {
          amount: parseFloat(selectedDocument.amount),
          documentId: null,
          dueDate: null,
          key: counter + 1,
        },
      ])
      setOpen(false)
      setLoading(false)
    }

    const { executeMutation } = CreateCheckDocument()

    const isDisabled = document.length === 0
    const handleSubmit = async () => {
        try {
            setLoading(true)
            const input = document.map((d) => ({ documentId: String(d.documentId), amount: parseFloat(d.amount), dueDate: moment(d.dueDate, 'YYYY-MM-DD').toDate() }))
            const { data, error } = await executeMutation({ companyId, documentId: selectedDocument.id, input })

            handleClose()

            if (error) {
              return dispatch(
                  importAlertState({
                    content: "Error al saldar, intente nuevamente.",
                    state: "error",
                    duration: 3,
                  })
                )
            }

            dispatch(importUpdateCashflowNeeded({ value: true, reload: null }))
            dispatch(updateConcilieantionRatio());
            dispatch(setUpdateDocuments({ value: true }))

            dispatch(
                importAlertState({
                  content: selected.length > 1 ? "Documentos saldados con éxito" : "Documento saldado con éxito",
                  state: "success",
                  duration: 3,
                })
              )
            setLoading(false)
        } catch (error) {
            setLoading(false)
            console.error(error);
        }
    }

    const deleteRow = (key) => {
        const newCheques = document.filter((f) => f.key !== key);
        setDocument(newCheques);
    }

    const updateDocument = (value, key, type) => {
      document.map((element) => {
        if (element.key === key) {
          if (type === "documentId") {
            element.documentId = value;
          }
          if (type === "amount") {
            element.amount = value;
          }
          if (type === "dueDate") {
            element.dueDate = value;
          }
        }
      });
    };

    return (
        <>
            <Dropdown.Item value={option?.value} onClick={handleOpen}>
                {option?.text}
            </Dropdown.Item>
            <CustomModal
                open={open}
                onClose={handleClose}
                dimmer="blurring"
                size="small"
                title={ `¿Estás seguro que deseas saldar con cheque este documento? (${CurrencyIcon[selectedDocument.currencyType]} ${selectedDocument.meta?.remaining ?? selectedDocument.amount})` }
                content={
                    <>
                <p>Seleccione el número de cheque, monto y fecha de pago</p>
                <Card className="d-flex w-100">
                <Card.Content className="m-0">
                  {document.map((data, index) => {
                    return (
                      <div
                        className={`d-flex align-items-center justify-content-between ${
                          index !== document.length - 1 ? "mb-3" : ""
                        }`}
                        key={data?.key}
                      >
                        <Input icon iconPosition="left">
                          <Icon name="tag" />
                          <input
                            placeholder="Número de cheque"
                            onChange={(e) => {
                              const type = "documentId";
                              updateDocument(e.target.value, data.key, type);
                            }}
                            value={document.documentId}
                          />
                        </Input>
                        <Input icon iconPosition="left">
                          <Icon name={selectedDocument.currencyType == 'EUR' ? 'euro' : selectedDocument.currencyType == 'GBP' ? 'pounds' : 'dollar sign'} />
                          <input
                            placeholder="Indique el monto"
                            type='number'
                            onChange={(e) => {
                              const type = "amount";
                              updateDocument(e.target.value, data.key, type);
                            }}
                            defaultValue={data.amount}
                          />
                        </Input>
                        <Input icon iconPosition="left">
                          <Icon name="calendar" />
                          <input
                            type="date"
                            onChange={(e) => {
                              const type = "dueDate";
                              updateDocument(e.target.value, data.key, type);
                            }}
                            defaultValue={data.dueDate}
                          />
                        </Input>
                        <Icon
                          link
                          name="minus circle"
                          onClick={() => deleteRow(data.key)}
                        />
                      </div>
                    );
                  })}
                </Card.Content>
              </Card>
              <Button
                basic
                color="black"
                onClick={() => {
                  const newCounter = counter + 1
                  setCounter(newCounter);
                  setDocument((currentValue) =>  {

                    const totalAmount = currentValue.reduce((acc, curr) => {
                      acc =+ curr.amount
                      return acc
                    }, 0)

                    const amount = Math.max(0, selectedDocument.amount - totalAmount)

                    return currentValue.concat({
                      amount: amount,
                      documentId: null,
                      dueDate: null,
                      key: currentValue.length + 1,
                    })
                  });
                }}
              >
                + Agregar Cheque
              </Button>
                    </>
                }
                customActions={
                    <div className="tw-flex tw-justify-end tw-gap-2 tw-w-full tw-flex-wrap">
                        <ScfoButton type="button" variant="ghost" onClick={handleClose}>
                            Cancelar
                        </ScfoButton>
                        <ScfoButton
                            type="button"
                            variant="primary"
                            onClick={handleSubmit}
                            loading={loading}
                            disabled={isDisabled}
                        >
                            Sí, saldar
                        </ScfoButton>
                    </div>
                }
            />
        </>
    );
};
